import { render, staticRenderFns } from "./UpPortal.vue?vue&type=template&id=16847a8d&scoped=true&lang=pug"
import script from "./UpPortal.vue?vue&type=script&lang=js"
export * from "./UpPortal.vue?vue&type=script&lang=js"
import style0 from "./UpPortal.vue?vue&type=style&index=0&id=16847a8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16847a8d",
  null
  
)

export default component.exports